import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=23961d70&scoped=true&"
import script from "./BaseSidebar.vue?vue&type=script&lang=ts&"
export * from "./BaseSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=23961d70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23961d70",
  null
  
)

export default component.exports